export default "__VITE_ASSET__bf1547ac__"